if (process.env.NODE_ENV === 'production') {
  module.exports = require('./Urls.prod');
} else {
  module.exports = require('./Urls.dev');
}
